module.exports = __webpack_public_path__ + "img/favicon.05aa93e9.png";